import { render, staticRenderFns } from "./BillPromissory.vue?vue&type=template&id=f126974e"
import script from "./BillPromissory.vue?vue&type=script&lang=js"
export * from "./BillPromissory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports